import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RequisitionsList from './RequisitionsList';
import CreateRequisition from './CreateRequisition';
import ViewRequisition from './ViewRequisition';
import RequisitionEdit from './RequisitionEdit';
import Archive from './Archive';
import Junk from './Junk';
import PurchaseOrdersList from './PurchaseOrdersList';
import ViewPurchaseOrder from './ViewPurchaseOrder';

function Requisitions() {
  return (
    <Routes>
      <Route index element={<RequisitionsList status="pending" />} />
      <Route path="archive" element={<Archive />} />
      <Route path="junk" element={<Junk />} />
      <Route path="po" element={<PurchaseOrdersList />} />
      <Route path="po/:requisitionId" element={<ViewPurchaseOrder />} />
      <Route path="create/:specificationId" element={<CreateRequisition />} />
      <Route path=":requisitionId" element={<ViewRequisition />} />
      <Route path="edit/:requisitionId" element={<RequisitionEdit />} />
    </Routes>
  );
}

export default Requisitions;